import type { NewsResponseAuth } from './newsResponseAuth';
import type { NewsResponseBasicInfo } from './newsResponseBasicInfo';
import type { NewsResponseContent } from './newsResponseContent';
import type { NewsResponseMedia } from './newsResponseMedia';
import type { NewsResponseSource } from './newsResponseSource';

export interface NewsResponse {
  /** 인증 컨텍스트 정보 */
  auth?: NewsResponseAuth;
  basicInfo?: NewsResponseBasicInfo;
  /** 뉴스 내용 정보 */
  content?: NewsResponseContent;
  /** 미디어 정보 */
  media?: NewsResponseMedia;
  /** 뉴스 출처 정보 */
  source?: NewsResponseSource;
}
